/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
`;

export const ItemDetails = styled.div`
  display: flex;
  align-items: center;
`;

export const Circle = styled.div`
  background-color: rgb(${({ color }) => color}, 0.25);
  border: 2px solid rgb(${({ color }) => color});
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 8px;
`;

export const Title = styled.div`
  color: ${Palette.PrimaryGray._700};
  font-size: 14px;
`;

export const Sum = styled.div`
  color: ${Palette.PrimaryGray._700};
  font-weight: 700;
`;
